// Central API prefix for backend calls. Set REACT_APP_API_URL in .env to change.
export const API_PREFIX = process.env.REACT_APP_API_URL || '';

export default API_PREFIX;
